import(/* webpackMode: "eager" */ "/wagfwafwaefw/app/global-error.tsx");
